import { FeatureSwitchesScreen } from './FeatureSwitchesScreen';

export function FeatureSwitchesRoute() {
  return <FeatureSwitchesScreen />;
}
